const floorplan = {
  floorplan: 'Floor Plan',
  add_floorplan: 'New Floor Plan',
  upload_floorplan: 'Upload Floor Plan',
  remove_floorplan: 'Remove Floor Plan',
  live_view: 'Live view',
  live_view_title: 'Floor Plan - Live View - {{name}}',
  delete_image_msg: 'Are you sure you want to remove the floor plan image?',
  last_activity: 'Last Events',
  events: 'Events',
  no_events: 'NO EVENTS',
  disable_credential: 'Disable Credential',
  disable_credential_msg: 'Are you sure you want to disable this credential?',
  credential_disabled: 'Credential Disabled',
  all: 'All',
  snap_to_grid_while_dragging: 'Snap to grid while dragging',
  snap_to_grid_after_drop: 'Snap to grid after drop',
  form: {
    available_allusers: 'Available for all users',
    small_icons: 'Small Icons',
    doors: 'Doors',
  },
  badge_photo: {
    error: 'Error loading image',
    no_image: 'No image',
  },
};

export default floorplan;
